import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import { loadGoogleMaps } from '../../utils/google-maps-loader';

class FindCourt {
	constructor () {
		this.initEvents();
	}

	initEvents() {
		// Events on Tabs Changes and Searches
		const listButton = SelectorEngine.findOne('.lta-court-search-tabs #lta-view-tab-1');
		const mapButton = SelectorEngine.findOne('.lta-court-search-tabs #lta-view-tab-2');
		const sortBy = SelectorEngine.findOne('.lta-court-search .lta-filter-panel__sort-by');
		const sortByChild = SelectorEngine.findOne('.lta-modal-fullscreen #sort-id');
		const mapWrap = SelectorEngine.findOne('.lta-mapWrapper');
		const SortByMobile = sortByChild ? sortByChild.parentNode.parentNode : null

		EventHandler.on(mapButton, 'click', (e) => {
			e.preventDefault();
			sortBy.classList.add('is-disabled');
			SortByMobile.classList.add('u-hidden');
		});

		EventHandler.on(listButton, 'click', (e) => {
			e.preventDefault();
			sortBy.classList.remove('is-disabled');
			SortByMobile.classList.remove('u-hidden');
		});
	}

	loadMap () {
		const mapWrap = SelectorEngine.findOne('.lta-mapWrapper');

		loadGoogleMaps()
			.then((google) => {
				this.map = new google.maps.Map(mapWrap, this.setMapOptions());
				this.setMarkers();
				mapWrap.classList.remove('lta-loader');
				return true;
			}).catch((error) => {
				return error;
			});
	}

	setMapOptions() {
		return {
			zoom: 12,
			disableDefaultUI: true,
			styles: [
				{
					"featureType": "road.all",
				}
			]
		};
	}

	setMarkers(state) {
		if (!state.points)
			return;

		state.points.forEach( function (item, i) {
			var marker;
			if (item.latitude ===0 || item.longitude === 0)
				return;

				marker = new google.maps.Marker({
					position: new google.maps.Lating(item.latitude, item.longitude),
					map: state.map,
					title: item.title
				});

				EventHandler.on(marker, 'click', () => {

				});
		});
	}
}

const globalFindCourt = new FindCourt();

export default globalFindCourt;

